import React, { useCallback, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";

// Components
import BaseModal from "~/components/modals/BaseModal";
// Styles
import s from "~/components/modals/error/ErrorModal.module.scss";
// hooks
import { useStore } from "~/hooks/useStore";
import { useAppointmentSteps } from "~/hooks/useAppointmentSteps";
import { logEvent } from "~/utils/amplitude";

interface Props {
  isOpened: boolean;
  width?: number;
}

export const GlobalErrorModal: React.FC<Props> = observer(
  ({ isOpened = false, width = "510px" }) => {
    const store = useStore();
    const navigate = useNavigate();
    const errorMessageText = store.egisErrorStore.egisErrorMessage;
    const { recalculateStepsStatusBasedOnRoutes } = useAppointmentSteps();

    const onClose = useCallback(() => {
      const redirectTo = store.egisErrorStore.redirectOnError;
      if (redirectTo) {
        navigate(redirectTo, { replace: true });
        recalculateStepsStatusBasedOnRoutes(redirectTo);
      }
      store.egisErrorStore.setIsEgisError(false);
    }, [navigate, store.egisErrorStore, recalculateStepsStatusBasedOnRoutes]);

    useEffect(() => {
      isOpened &&
        logEvent("О/ Ошибка данных", {
          "Сообщение в ошибке": errorMessageText,
        });
    }, [isOpened, errorMessageText]);

    return (
      <BaseModal
        width={width}
        isOpened={isOpened}
        onClose={onClose}
        onConfirm={onClose}
        textClose=""
        textConfirm="ОК"
        maxButtonWidth="100px"
        centered
      >
        <div className={"headline-2 " + s.errorTitle}>
          <p>Ошибка</p>
        </div>
        <p>{errorMessageText}</p>
      </BaseModal>
    );
  }
);

export default GlobalErrorModal;
